export default __webpack_public_path__ + "static/media/web_screen_meetings_es.6c0427a6.png";